import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneStaff from '../ones/OneStaff';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import StaffRegistrationForm from "../ones/StaffRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getAllStaff();
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allStaff])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && appContext.allStaff) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							Staff
						</h6>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<h6
									className="sub-section-title"
								>
									Register New Staff
								</h6>
								<hr/>

								<StaffRegistrationForm/>
								
							</div>
						</div>
					</div>

					<div className="col-md-12" id="_coinsOrdersList">
						<div
							className="card"
						>
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="sub-section-title"
										
									>
										All Staff
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										onChange={(e) => setSearchFilter(e.target.value)}
										placeholder="Filter by name"
									/>

								</div>
								<hr/>

								{
									(appContext.allStaff && appContext.allStaff.length > 0) ?
										appContext.allStaff.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.firstName).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 ||
													String(item.middleName).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 ||
													String(item.lastName).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1
												) {
													return (
														<OneStaff data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OneStaff data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No staff was found
										</h6>
								}
							</div>

						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}